exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-stripe-payout-details_reconciliation-col .presenter-reconciliation{margin-left:0}.c-stripe-payout-details_ignore svg{vertical-align:middle}", ""]);

// exports
